import { baseApi } from './baseApi';

export const imeiApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchImeis: builder.query({
      query: (params) => ({
        url: '/imei',
        params,
      }),
      providesTags: ['Imei'],
    }),
    getImeiByNumber: builder.query({
      query: (imei) => `/imei/${encodeURIComponent(imei)}`,
      providesTags: ['Imei'],
    }),
    directSupplierExchange: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/imei/${id}/supplier-exchange`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Imei', 'Product', 'StockLocation'],
    }),
    reassignSupplier: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/imei/${id}/reassign-supplier`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Imei'],
    }),
    correctImei: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/imei/${id}/correct`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Imei', 'Product'],
    }),
  }),
});

export const {
  useSearchImeisQuery,
  useGetImeiByNumberQuery,
  useDirectSupplierExchangeMutation,
  useReassignSupplierMutation,
  useCorrectImeiMutation,
} = imeiApi;
